import React, { useContext, useEffect, useRef, useState } from 'react';
import classNames from 'classnames/bind';
import styles from './EditTip.module.scss';
import { getData, postData } from '~/helper/apiService';
import { ToastContext } from '../Context/ToastProvider';
import { FetchDataContext } from '../Context/FetchDataProvider';
import { ModalOverLayContext } from '../Context/ModalOverLayProvider';
import TipForm from '../Form/TipForm';

const cx = classNames.bind(styles);

function EditTip({ id }) {
  const fileInputRef = useRef(null);
  const [key, setKey] = useState('');
  const [tip, setTip] = useState({});
  const [tipTypes, setTipTypes] = useState([]);
  const { addToast } = useContext(ToastContext);
  const { loadTips } = useContext(FetchDataContext);
  const { setModalComponentContent } = useContext(ModalOverLayContext);

  const loadData = async () => {
    try {
      const [tipRes, typesRes] = await Promise.all([
        getData(`/tips/read/${id}`),
        getData('/tips/readtype'),
      ]);
      if (tipRes) {
        setTip(tipRes);
      } else {
        addToast({ status: 'error', title: 'Lỗi', content: 'Không thể tải dữ liệu tip' });
      }
      if (typesRes && Array.isArray(typesRes)) {
        setTipTypes(typesRes);
      } else {
        addToast({ status: 'error', title: 'Lỗi', content: 'Không thể tải danh sách loại tip' });
      }
    } catch (error) {
      console.error('Error loading data:', error);
      addToast({ status: 'error', title: 'Lỗi', content: 'Không thể tải dữ liệu, vui lòng thử lại' });
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    formData.append('id', id);

    try {
      const res = await postData('/tips/update', formData);
      if (res.status === 'success') {
        loadTips();
        setKey((prev) => prev + 1);
        setModalComponentContent(null);
        addToast({ status: 'success', title: 'Thành công', content: 'Cập nhật tip thành công' });
      } else {
        addToast({ status: res.status, title: res.title || 'Lỗi', content: res.content || 'Cập nhật tip thất bại' });
      }
    } catch (error) {
      console.error('Error updating tip:', error);
      addToast({ status: 'error', title: 'Lỗi', content: 'Không thể gửi form, vui lòng thử lại' });
    }
  };

  return (
    <div className={cx('wrapper')}>
      <TipForm
        keyForm={key}
        titleBtn="Cập nhật tip"
        data={tip}
        types={tipTypes}
        handleSubmit={handleSubmit}
        fileInputRef={fileInputRef}
      />
    </div>
  );
}

export default EditTip;